/**
 * Chuỗi IMEI trên phiếu kho thường là CSV dài một dòng hoặc nhiều dòng.
 * Tách theo xuống dòng và dấu phẩy, đánh STT để hiển thị dễ đọc và wrap trong bảng.
 */
export function formatImeiListForDisplay(productItem) {
  const raw =
    productItem && productItem.IMEI != null
      ? String(productItem.IMEI).trim()
      : '';
  if (!raw) {
    return '';
  }

  const parts = raw
    .split(/\r\n|\r|\n|,/)
    .map((s) => s.trim())
    .filter(Boolean);

  if (parts.length === 0) {
    return '';
  }

  return parts.map((imei, index) => `${index + 1}) ${imei}`).join('\n');
}
